import React from 'react';

import {labels} from '../../../../../util/utils';
import {contactListColumnIds} from '../../../../../util/uiconstants';
import {RECIPIENTS_SELECTED_LIST} from '../../../../Pages/ContactDB/Toolbar/GenerateMessage/GMForm/utils/constants';

import {IconoirTrash} from '@ey-xd/motif-icon';

import Button from '../../../../CoreWrappers/Button';

const DeleteColumn = ({item, handleDelete}) => {
	const props = {
		title: labels.removeTooltip,
		svg: IconoirTrash,
		onClick: (e) => handleDelete(item.userId),
		variant: 'ghost'
	};

	return <Button {...props} />;
};

export const config = (handleDelete) => ({
	id: contactListColumnIds.delete,
	label: '',
	propName: 'delete',
	width: 'var(--px-103)',
	customCell: (item) => {
		const props = {item, handleDelete};
		return <DeleteColumn {...props} />;
	}
});
